import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type WhatsAppGroup = {
    id: string;
    name: string;
    memberCount: number;
};

export const GET_WHATSAPP_GROUPS_QUERY_KEY = (organizationId: string) =>
    ['organization', organizationId, 'whatsappGroups'];

export const useGetWhatsAppGroups = (organizationId: string, enabled: boolean) => {
    const apiClient = useApiClient();

    return useQuery<WhatsAppGroup[]>({
        queryKey: GET_WHATSAPP_GROUPS_QUERY_KEY(organizationId),
        queryFn: () =>
            apiClient.fetchApi<WhatsAppGroup[], {}>({
                method: 'GET',
                endpoint: `organizations/${organizationId}/whatsapp-groups`,
            }),
        enabled: !!organizationId && enabled,
    });
};
